import { Card, CardBody, Col, Form, Input, Label } from "reactstrap";
import { P } from "../../../../AbstractElements";
import { BorderRightTitle, EmailAddress } from "../../../../Constants/Constants";
import { BorderRightSubTitle } from "../../../../Data/BonusUi/CreativeCard";
import CommonCardHeader from "../../../CommonComponents/CommonCardHeader/CommonCardHeader";

const BorderRight = () => {
  return (
    <Col md="6" xs="12">
      <Card>
        <CommonCardHeader title={BorderRightTitle} span={BorderRightSubTitle} headClass="border-r-secondary" />
        <CardBody>
          <P>{"Us Technology offers web & mobile development solutions for all industry verticals.Include a short form using fields that'll help your business understand who's contacting them."}</P>
          <Form>
            <Label>{EmailAddress}</Label>
            <Input type="email" placeholder="youremail@gmail.com" />
          </Form>
        </CardBody>
      </Card>
    </Col>
  );
};
export default BorderRight;
